/**
 * Сцена первого входа (ТЗ UI-64 … UI-66).
 *
 * Визуальный мотив продукта — упорядоченные фрагменты слов, клавиш и
 * ритмических меток (UI-08): ретро-машинописи и клавиатурных фотографий здесь
 * нет. Запрещённого списком UI-71 нет тоже — ни рук на «правильных» клавишах,
 * ни глаз, ни позы, ни обещаний ускорения: чего продукт не видит, того он и
 * не рисует.
 *
 * Что она говорит: разрозненные куски слова слева собираются в ровную строку
 * клавиш справа, а под строкой — ровный ритм. Это и есть обещание продукта:
 * не «быстро», а «ровно» — и оно про набор, а не про человека. Рук, глаз и
 * пальцев здесь нет намеренно: чего продукт не видит, того он и не рисует
 * (ТЗ UI-06).
 *
 * Текста внутри тоже нет: рисунок с надписью пришлось бы переводить, а
 * перевод внутри картинки живёт отдельно от словаря и расходится с ним.
 *
 * Цвет — только токены (ТЗ UI-65), поэтому смена темы перекрашивает сцену без
 * замены файла. Для чтения с экрана она скрыта: рядом стоит текст, который
 * говорит то же самое словами.
 */

export function OnboardingArt(): React.JSX.Element {
  return (
    <svg
      className="t2x-onboarding__art"
      viewBox="0 0 480 360"
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      {/* Слева — куски слова: разной длины, вразнобой, вне общей линии. */}
      <g fill="var(--t2x-surface-alt)" stroke="var(--t2x-border-strong)" strokeWidth="2">
        <rect x="24" y="44" width="74" height="30" rx="10" transform="rotate(-9 61 59)" />
        <rect x="42" y="112" width="52" height="30" rx="10" transform="rotate(7 68 127)" />
        <rect x="16" y="182" width="88" height="30" rx="10" transform="rotate(-4 60 197)" />
        <rect x="52" y="252" width="46" height="30" rx="10" transform="rotate(11 75 267)" />
      </g>

      {/* Переход: линия измерения, вдоль которой куски выстраиваются. */}
      <path
        d="M126 180 H196"
        stroke="var(--t2x-muted)"
        strokeWidth="2"
        strokeDasharray="6 6"
        fill="none"
      />
      <path
        d="M188 170 l14 10 -14 10"
        stroke="var(--t2x-muted)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="square"
      />

      {/* Справа — ровный ряд клавиш на одной линии. */}
      <g stroke="var(--t2x-accent)" strokeWidth="2">
        <rect x="222" y="120" width="54" height="54" rx="12" fill="var(--t2x-accent-soft)" />
        <rect x="286" y="120" width="54" height="54" rx="12" fill="var(--t2x-accent-soft)" />
        <rect x="350" y="120" width="54" height="54" rx="12" fill="var(--t2x-accent-soft)" />
        <rect x="414" y="120" width="42" height="54" rx="12" fill="var(--t2x-accent-soft)" />
      </g>

      {/* Опора строки: та самая ровная линия, к которой всё пришло. */}
      <path d="M222 192 H456" stroke="var(--t2x-border-strong)" strokeWidth="2" fill="none" />

      {/*
        Ритм: точки одного размера через равные промежутки. Ровный темп — то,
        что тренажёр действительно измеряет, в отличие от «скорости к пятнице».
      */}
      <g fill="var(--t2x-highlight)">
        <circle cx="230" cy="222" r="6" />
        <circle cx="268" cy="222" r="6" />
        <circle cx="306" cy="222" r="6" />
        <circle cx="344" cy="222" r="6" />
        <circle cx="382" cy="222" r="6" />
        <circle cx="420" cy="222" r="6" />
      </g>

      {/* Слева от перехода ритм ещё рваный: промежутки разные. */}
      <g fill="var(--t2x-muted)">
        <circle cx="26" cy="316" r="6" />
        <circle cx="52" cy="316" r="6" />
        <circle cx="104" cy="316" r="6" />
        <circle cx="122" cy="316" r="6" />
      </g>
    </svg>
  );
}
